import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Outlet, Link, useLocation } from 'react-router-dom';
import './AdminPanel.css';

function AdminPanel() {
  const location = useLocation();

  return (
    <Container fluid className="admin-panel-container py-5 mt-5">
      <Row>
        {/* Sidebar */}
        <Col md={3} lg={2} className="admin-sidebar">
          <div className="sidebar-header mb-4">
            <h4>Administration</h4>
            <p className="text-muted">Panneau de contrôle</p>
          </div>
          
          <Nav className="flex-column">
            <Nav.Link 
              as={Link} 
              to="/admin/dashboard" 
              className={`sidebar-link ${location.pathname === '/admin/dashboard' ? 'active' : ''}`}
            >
              <i className="fas fa-tachometer-alt me-2"></i> Tableau de bord
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/admin/users" 
              className={`sidebar-link ${location.pathname === '/admin/users' ? 'active' : ''}`}
            >
              <i className="fas fa-users me-2"></i> Utilisateurs
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/admin/partners" 
              className={`sidebar-link ${location.pathname === '/admin/partners' ? 'active' : ''}`}
            >
              <i className="fas fa-handshake me-2"></i> Partenaires
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/admin/events" 
              className={`sidebar-link ${location.pathname === '/admin/events' ? 'active' : ''}`}
            >
              <i className="fas fa-calendar-alt me-2"></i> Événements
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/admin/settings" 
              className={`sidebar-link ${location.pathname === '/admin/settings' ? 'active' : ''}`}
            >
              <i className="fas fa-cog me-2"></i> Paramètres
            </Nav.Link>
          </Nav>
          
          <div className="sidebar-footer mt-auto pt-4">
            <Nav.Link as={Link} to="/" className="sidebar-link">
              <i className="fas fa-home me-2"></i> Retour au site
            </Nav.Link>
          </div>
        </Col>
        
        {/* Content */}
        <Col md={9} lg={10} className="admin-content">
          <Outlet />
          
          {/* Default content if no sub-route is matched */}
          {location.pathname === '/admin' && (
            <div className="text-center py-5">
              <h2>Bienvenue dans le panneau d'administration</h2>
              <p className="text-muted">Sélectionnez une option dans le menu pour commencer</p>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default AdminPanel;